import styled from 'styled-components'
import { Box } from '@rebass/grid'

const Container = styled(Box).attrs({
  mx: 'auto',
  px: 4
})`
  max-width: 1200px;
  z-index: 200;
  position: relative;
`

export default Container
